<template>
  <div id="school">
    <div class="row justify-content-center">
      <div class="col-12 col-md-6">
        <form-layout
          title=""
          submit-text="Top up"
          :show-loading="updatingForm"
          :show-reset="false"
          :show-submit="false"
          submit-button-name="update-school"
        >
          <template slot="form-header">
            <div class="d-flex justify-content-center mb-2">
              <div class="d-flex flex-column justify-content-start">
                <div class="text-center mb-2">
                  <b-avatar
                    size="30px"
                    :variant="hasActivatedSmsAccount?'light-success':'light-danger'"
                  >
                    <feather-icon
                      size="20px"
                      :icon="hasActivatedSmsAccount?'CheckCircleIcon':'XCircleIcon'"
                    />
                  </b-avatar>
                </div>
                <div
                  style="font-size: 15px;"
                >
                  <div
                    v-if="hasActivatedSmsAccount"
                    class="row justify-content-center"
                  >
                    <div class="col-md-8 text-center">
                      <div>
                        <b>SMS CREDITS: {{ smsBalance }}</b>
                      </div>
                      <small class="text-danger">NB: If SMS credits is negative, then your last sms cost more than your
                        balance and will be deducted when you top up.</small>
                    </div>
                    <div
                      v-if="amount"
                      class="col-md-8"
                    >
                      <b>TOTAL CREDITS: {{ credits }}</b>
                    </div>
                    <div class="col-md-8">
                      <sikanii-input
                        v-model="amount"
                        name="amount"
                        type="number"
                        rules="gt:0"
                        placeholder="Amount (GHS)"
                        :label="`Top Up Amount (<small class='text-danger'><b>Transaction fees may apply</b></small>)`"
                      />
                    </div>
                    <div class="col-md-8">

                      <sikanii-button
                        variant="outline-primary"
                        label="Top Up"
                        class="float-right"
                        :loading="loading"
                        :disabled="!amount"
                        @click="topUpSms()"
                      />
                    </div>
                  </div>
                  <div
                    v-else
                    class="text-align: center; row justify-content-center"
                  >
                    <div class="col-md-8 text-center">
                      Your <strong>sms</strong> account has not been activated, please
                      click on the button below to begin activation process.
                    </div>
                  </div>
                  <div v-if="hasActivatedSmsAccount">
                    <div class="row justify-content-center mt-2">
                      <div class="col-md-8">
                        <sikanii-input
                          v-model="sms.sender_name"
                          name="sender_name"
                          placeholder="Sender Name"
                          label="Sender Name(This may take between minutes to hours to get approved, until then we will use your old sender name)."
                          rules="max_length:10"
                        />
                      </div>
                      <div
                        v-if="!isActive"
                        class="col-md-8 text-danger"
                      >
                        <small><b>You will be able to send a test sms once your sms account is fully activated.</b></small>
                      </div>
                      <div class="col-md-8">
                        <sikanii-button
                          :disabled="!sms.sender_name"
                          class="float-right mb-1 ml-1"
                          label="Save"
                          @click="showPasswordModal()"
                        />
                        <sikanii-button
                          v-if="isActive"
                          variant="outline-primary"
                          class="float-right mb-1"
                          label="Send a Test Notification"
                          @click="sendTestSms()"
                        />
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="text-center mt-2">
                      <sikanii-button
                        label="Activate"
                        @click="activateSmsAccount()"
                      />
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="d-flex justify-content-center">
              <sikanii-button
                variant="flat-primary"
                label="Setup Customer Sms Configs"
                icon="MessageCircleIcon"
                @click="()=>{smsConfigModalOpened=true}"
              />
            </div>
          </template>
        </form-layout>
      </div>
    </div>
    <sikanii-modal
      title="Confirm Your Password"
      :show="passwordModalOpened"
      :hide-footer="!password"
      ok-text="Continue"
      :loading="updating"
      @onClose="passwordModalOpened=false"
      @onOk="updateSenderName()"
    >
      <sikanii-input
        v-model="password"
        label="Password"
        type="password"
        rules="required"
        placeholder="Please enter your password"
      />
    </sikanii-modal>
    <sikanii-modal
      title="Sms Configs"
      :show="smsConfigModalOpened"
      :ok-disabled="!validConfig"
      ok-text="Save"
      :loading="updating"
      @onClose="smsConfigModalOpened=false"
      @onOk="updateConfig()"
    >
      <error-display :error="error" />
      <b-form-checkbox
        v-model="config.charge_sms"
        class="mb-1"
      >
        Charge Sms From Customer Balance
      </b-form-checkbox>
      <sikanii-select
        v-model="config.frequency"
        label="How Often?"
        label-name="label"
        value-name="id"
        :options="frequency"
        :rules="config.charge_sms?'required':''"
        placeholder="Select Frequency"
      />
      <sikanii-input
        v-model="config.duration"
        label="Duration"
        type="duration"
        :rules="config.charge_sms?'required':''"
        placeholder="Please Enter Duration"
      />
      <sikanii-input
        v-model="config.amount"
        label="Amount"
        type="number"
        :rules="config.charge_sms?'required|gt:0':''"
        placeholder="Please enter an amount"
      />
      <b-form-checkbox
        v-model="sendSms"
      >
        Send Sms on Every Transaction
      </b-form-checkbox>
    </sikanii-modal>
  </div>
</template>

<script>
import { BAvatar, BFormCheckbox } from 'bootstrap-vue'
import FormLayout from '@/layouts/FormLayout.vue'
import SikaniiInput from '@/layouts/components/SikaniiInput.vue'
import showToast from '@/libs/mixins/showToast'
import SikaniiButton from '@/layouts/components/SikaniiButton.vue'
import confirm from '@/libs/mixins/confirm'
import SikaniiModal from '@/layouts/components/SikaniiModal.vue'
import http from '@/libs/axios'
import SikaniiSelect from '@/layouts/components/SikaniiSelect.vue'
import ErrorDisplay from '@/layouts/components/ErrorDisplay.vue'

export default {
  name: 'Company',
  components: {
    ErrorDisplay,
    SikaniiSelect,
    SikaniiModal,
    SikaniiButton,
    SikaniiInput,
    FormLayout,
    BAvatar,
    BFormCheckbox,
  },
  mixins: [showToast, confirm],
  data() {
    return {
      password: null,
      sms: {
        sender_name: null,
      },
      amount: null,
      price: 0.04,
      error: {},
      passwordModalOpened: false,
      updatingForm: false,
      updating: false,
      loading: false,
      sendSms: true,
      config: {
        charge_sms: null,
        frequency: null,
        duration: null,
        amount: null,
        sms_disabled: true,
      },
      smsConfigModalOpened: false,
      frequency: [
        {
          label: 'Weekly',
          id: 'weekly',
        },
        {
          label: 'Bi-weekly',
          id: 'bi-weekly',
        },
        {
          label: 'Monthly',
          id: 'monthly',
        },
      ],
    }
  },
  computed: {
    validConfig() {
      if (this.config.config_sms) {
        return this.config.amount && this.config.frequency && this.config.duration
      }
      return true
    },
    hasActivatedSmsAccount() {
      return this.$store.getters['auth/hasActivatedSmsAccount']
    },
    credits() {
      return +this.amount / this.price
    },
    smsBalance() {
      return this.$store.getters['auth/smsBalance']
    },
    isActive() {
      return this.$store.getters['auth/smsActivated']
    },
    companyInfo() {
      return this.$store.getters['auth/company']
    },
  },
  watch: {
    sendSms(val) {
      this.config.sms_disabled = !val
    },
  },
  mounted() {
    this.updateFields()
    this.getSmsBalance()
    this.getConfig()
  },
  methods: {
    topUpSms() {
      this.loading = true
      this.$http.post('sms-settings/initiate-sms-top-up', { amount: this.amount })
        .then(res => {
          this.showSuccess('Top up initiated successfully')
          window.open(res.data.authorization_url, '_blank')
        })
        .catch(err => {
          this.showError('Failed to initiate top up')
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateFields() {
      this.sms.sender_name = this.companyInfo.sms_sender_name
    },
    getSmsBalance() {
      this.$http.get('sms-settings/balance')
        .then(res => {
          this.$store.commit('auth/setSmsBalance', res.data)
        })
    },
    getConfig() {
      this.updating = true
      this.$http.get('user-accounts/sms-config')
        .then(res => {
          this.config = res.data
        }).finally(() => {
          this.updating = false
        })
    },
    updateConfig() {
      this.updating = true
      this.error = {}
      this.config.sms_disabled = !this.sendSms
      this.$http.put('user-accounts/sms-config', this.config)
        .then(res => {
          this.config = res.data
          this.showSuccess('Updated successfully')
        }).catch(err => {
          this.error = err
          this.showError('Failed to update config')
        }).finally(() => {
          this.updating = false
        })
    },
    activateSmsAccount() {
      this.confirmAction('Please confirm this action.')
        .then(res => {
          if (res) {
            this.updatingForm = true
            this.$http.post('sms-settings/activate')
              .then(res => {
                this.updatingForm = false
                this.showSuccess('Activation request has been sent successfully,'
                        + ' you will be contacted by a Sikanii Rep to begin the process.')
                this.$store.commit('auth/setSmsBalance', res.data)
              })
              .catch(err => {
                this.updatingForm = false
                this.showError('Something went wrong, please try again')
              })
          }
        })
    },
    showPasswordModal() {
      this.passwordModalOpened = true
    },
    updateSenderName() {
      this.updating = true
      this.$http.put('sms-settings/update-sender-name', { sender_name: this.sms.sender_name })
        .then(res => {
          this.showSuccess('Updated sender name successfully')
          this.$store.commit('auth/updateCompany', { sms_sender_name: this.sms.sender_name })
        })
        .catch(err => {
          this.showError('Failed to update sender name')
        }).finally(() => {
          this.updating = false
        })
    },
    sendTestSms() {
      this.confirmAction('When you confirm, a test SMS will be sent to your company\'s phone. This is how we test to confirm if your configuration was setup correctly.', 'Confirm')
        .then(res => {
          if (res) {
            this.$http.post('sms-settings/send-test-sms')
              .then(res => {
                this.showSuccess('You will receive a test SMS shortly. If you do not, please contact support.')
              })
              .catch(err => {
                this.showError('Something went wrong, please try again')
              })
          }
        })
    },
  },
}
</script>
